import React from 'react';

const ModeHelpTooltip = ({ onClose }) => {
  return (
    <div className="mode-help-overlay">
      <div className="mode-help-content">
        <h4>Connection Mode Help</h4>
        <button className="close-button" onClick={onClose}>×</button>
        <div className="help-text">
          <p><strong>Purpose:</strong> Define multi-modal transport connections between location points. Each connection represents a route segment with a specific transport mode (Bike/Truck/Train/Ship) and travel duration.</p>
          
          <p><strong>Operation Steps:</strong></p>
          <ol>
            <li><strong>Set Transport Demand (Optional):</strong>
              <ul>
                <li>Enter 0 for standard mode (no capacity constraints)</li>
                <li>Enter &gt;0 for capacity constraint mode</li>
              </ul>
            </li>
            <li><strong>Set Transport Mode Capacities (if demand &gt; 0):</strong>
              <ul>
                <li>Enter capacity for each transport mode (e.g., Truck: 50 units)</li>
                <li>System will calculate required trips based on demand/capacity</li>
              </ul>
            </li>
            <li><strong>Create Connections:</strong>
              <ul>
                <li>Click a transport mode button (Bike/Truck/Train/Ship)</li>
                <li>Button will highlight to show active connection mode</li>
                <li>Click the first location point on the map</li>
                <li>Click the second location point to complete connection</li>
                <li>Enter travel duration in hours in the popup dialog</li>
                <li>Click OK to save the connection</li>
              </ul>
            </li>
            <li><strong>Manage Connections:</strong>
              <ul>
                <li>View all created connections in the list</li>
                <li>Click × button to delete individual connections</li>
                <li>Click Clear All to remove all connections</li>
              </ul>
            </li>
          </ol>

          <p><strong>Transport Modes:</strong></p>
          <ul>
            <li><strong>Bike</strong> - Flexible, short-distance transport</li>
            <li><strong>Truck</strong> - Medium capacity, road transport</li>
            <li><strong>Train</strong> - High capacity, rail transport</li>
            <li><strong>Ship</strong> - Very high capacity, water transport</li>
          </ul>

          <p><strong>Import/Export:</strong></p>
          <ul>
            <li><strong>Import:</strong> Load connections from CSV file</li>
            <li><strong>Export CSV:</strong> Save connections data</li>
            <li><strong>Export GeoJSON:</strong> Save geographic visualization</li>
          </ul>

          <p><strong>Tips:</strong></p>
          <ul>
            <li>Click the same transport mode button again to cancel connection</li>
            <li>Create bidirectional connections if needed (A→B and B→A)</li>
            <li>Connection duration affects final route optimization</li>
            <li>Ensure all necessary point pairs are connected before solving</li>
          </ul>
        </div>
      </div>
    </div>
  );
};

export default ModeHelpTooltip;

